
import type { PropType } from 'vue'
import type Vue from 'vue'
import type { ExplainMessages, RegularFilter } from '../../../models'
import { defineComponent, getCurrentInstance } from 'vue'
import { FilterIdEnum } from '../../../enums/filter-id.enum'
import { EpbButton } from '../../shared/epb-button'
import ExplainDateRange from '../explain-date-range.component.vue'
import ExplainFilters from '../explain-filters.component.vue'
import ExplainHeaderDownloadButton from '../explain-header-download-button.component.vue'
import ExplainHeaderLayout from '../header-layout.component.vue'
import ExplainQueryAnalysisSearchBox from './search-box.component.vue'

export default defineComponent({
  name: 'ExplainQueryAnalysisHeader',
  components: {
    ExplainHeaderDownloadButton,
    ExplainHeaderLayout,
    ExplainQueryAnalysisSearchBox,
    ExplainDateRange,
    ExplainFilters,
    EpbButton,
  },
  props: {
    messages: {
      type: Object as PropType<ExplainMessages>,
      required: true,
    },
    loading: {
      type: Boolean,
      required: true,
    },
    filters: {
      type: Object as PropType<Record<string, RegularFilter>>,
      required: true,
    },
    showFilters: {
      type: Boolean,
      required: true,
    },
    showFiltersButton: {
      type: Boolean,
      required: true,
    },
  },
  setup() {
    const {
      proxy: { $epb },
    } = getCurrentInstance() as { proxy: Vue }

    const lastSevenDaysLabel = $epb.messages.filters.values[FilterIdEnum.DATE].lastSevenDays.label
    return {
      baseClass: 'epb-explain-query-analysis-header',
      lastSevenDaysLabel,
    }
  },
})
